// Module
var code = `<template>
  <mdc-dialog view-model.ref="dialog">
    <mdc-dialog-title>Create Corporation</mdc-dialog-title>
    <mdc-dialog-content>
      <div style="width: 100%; min-width: 400px;">
        <mdc-text-field label="Corporation Name" value.bind="model.name" style="width: 100%;" focus></mdc-text-field>
      </div>
    </mdc-dialog-content>
    <mdc-dialog-actions>
      <button mdc-button click.trigger="dialog.close('cancel')">Cancel</button>
      <button mdc-button click.trigger="dialog.close('ok')" disabled.bind="!model.name">Create</button>
    </mdc-dialog-actions>
  </mdc-dialog>
</template>
`;
// Exports
export default code;